import React from "react"

import { Container, Row, Col, Nav, NavLink } from "src/ui"
import Logo from "src/ui/img/logo.svg"

export const Footer: React.FC = () => {
  return (
    <div className="section footer-section mt-5 py-5 text-center">
      <Container>
        <Row>
          <Col sm="12">
            <div className="logo mb-4">
              <img className="mb-2" alt="" src={Logo} />
            </div>
            <Nav
              tag="div"
              className="nav-footer-main justify-content-center my-4"
            >
              <NavLink
                className="text-uppercase font-weight-bold text-dark"
                href="https://www.pulsarplatform.com/contact/"
              >
                Contact
              </NavLink>
              <NavLink
                className="text-uppercase font-weight-bold text-dark"
                href="https://www.pulsarplatform.com/solutions/"
              >
                Solutions
              </NavLink>
              <NavLink
                className="text-uppercase font-weight-bold text-dark"
                href="https://www.pulsarplatform.com/resources/"
              >
                Resources
              </NavLink>
              <NavLink
                className="text-uppercase font-weight-bold text-dark"
                href="https://www.pulsarplatform.com/request-a-demo/"
              >
                Request a demo
              </NavLink>
            </Nav>
            <Nav
              tag="div"
              className="nav-footer-secondary justify-content-center mb-2"
            >
              <NavLink
                // className="text-muted"
                href="https://www.pulsarplatform.com/privacy-policy/"
              >
                Privacy Policy
              </NavLink>
              <NavLink
                // className="text-muted"
                href="https://www.pulsarplatform.com/terms/"
              >
                UK T&amp;C
              </NavLink>
              <NavLink
                // className="text-muted"
                href="https://www.pulsarplatform.com/terms_us/"
              >
                US T&amp;C{" "}
              </NavLink>
            </Nav>
            <p className="small">©2020 Pulsar Platform All rights reserved</p>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
